
/* Round List */
export const GET_ROUND_LIST = "GET_ROUND_LIST";
export const GET_ROUND_LIST_SUCCESS = "GET_ROUND_LIST_SUCCESS";
export const GET_ROUND_LIST_FAIL = "GET_ROUND_LIST_FAIL";

//////////////csr round/////////////////
/* Round List */
export const GET_CSR_ROUND_LIST = "GET_CSR_ROUND_LIST";
export const GET_CSR_ROUND_LIST_SUCCESS = "GET_CSR_ROUND_LIST_SUCCESS";
export const GET_CSR_ROUND_LIST_FAIL = "GET_CSR_ROUND_LIST_FAIL";

////////////////////Round Participant////////////////////////
export const GET_ROUND_PARTICIPANT_LIST = "GET_ROUND_PARTICIPANT_LIST";
export const GET_ROUND_PARTICIPANT_LIST_SUCCESS = "GET_ROUND_PARTICIPANT_LIST_SUCCESS";
export const GET_ROUND_PARTICIPANT_LIST_FAIL = "GET_ROUND_PARTICIPANT_LIST_FAIL";

///Ading New Round
export const ADD_NEW_ROUND_LIST = "ADD_NEW_ROUND_LIST";
export const ADD_NEW_ROUND_LIST_SUCCESS = "ADD_NEW_ROUND_LIST_SUCCESS";
export const ADD_NEW_ROUND_LIST_FAIL = "ADD_NEW_ROUND_LIST_FAIL";

// Update Round
export const UPDATE_NEW_ROUND_LIST = "UPDATE_NEW_ROUND_LIST";
export const UPDATE_NEW_ROUND_LIST_SUCCESS = "UPDATE_NEW_ROUND_LIST_SUCCESS";
export const UPDATE_NEW_ROUND_LIST_FAIL = "UPDATE_NEW_ROUND_LIST_FAIL";

export const DELETE_ROUND = "DELETE_ROUND";
export const DELETE_ROUND_SUCCESS = "DELETE_ROUND_SUCCESS";
export const DELETE_ROUND_FAIL = "DELETE_ROUND_FAIL";

export const DELETE_ROUND_PARTICIPANT = "DELETE_ROUND_PARTICIPANT";
export const DELETE_ROUND_PARTICIPANT_SUCCESS = "DELETE_ROUND_PARTICIPANT_SUCCESS";
export const DELETE_ROUND_PARTICIPANT_FAIL = "DELETE_ROUND_PARTICIPANT_FAIL";


///////////////submitted resukt participants//////
export const GET_SUBMITTED_PARTICIPANTS = "GET_SUBMITTED_PARTICIPANTS";
export const GET_SUBMITTED_PARTICIPANTS_SUCCESS = "GET_SUBMITTED_PARTICIPANTS_SUCCESS";
export const GET_SUBMITTED_PARTICIPANTS_FAIL = "GET_SUBMITTED_PARTICIPANTS_FAIL";



///////////////submitted resukt participants//////
export const GET_UNSUBMITTED_PARTICIPANTS = "GET_UNSUBMITTED_PARTICIPANTS";
export const GET_UNSUBMITTED_PARTICIPANTS_SUCCESS = "GET_UNSUBMITTED_PARTICIPANTS_SUCCESS";
export const GET_UNSUBMITTED_PARTICIPANTS_FAIL = "GET_UNSUBMITTED_PARTICIPANTS_FAIL";

///////////////saved resukt participants//////
export const GET_SAVED_PARTICIPANTS = "GET_SAVED_PARTICIPANTS";
export const GET_SAVED_PARTICIPANTS_SUCCESS = "GET_SAVED_PARTICIPANTS_SUCCESS";
export const GET_SAVED_PARTICIPANTS_FAIL = "GET_SAVED_PARTICIPANTS_FAIL";